import { useEffect, useRef, useState } from "react";
import Modal from "./modal";
import Spinner from "./spinner";
import ReactDatePicker from "react-datepicker";
import { he } from "date-fns/locale";
import ReactSwitch from "react-switch";
import SERVICES from "../api/services/SERVICES";
import GIFT_CARDS from "../api/services/GIFT_CARDS";
import { format } from "date-fns";
import { toast } from "react-toastify";
import styles from "../styles/_components/createGiftCardModal.module.scss";

const CreateGiftCardModal = ({ setIsOpen, setResponseStatus }) => {
  const [name, setName] = useState("");
  const [priceType, setPriceType] = useState("");
  const [fixedPrice, setFixedPrice] = useState("");
  const [fixedPrices, setFixedPrices] = useState([]);
  const [expiryDate, setExpiryDate] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [minPrice, setMinPrice] = useState("");
  const [validService, setValidService] = useState("");
  const [validServices, setValidServices] = useState([]);
  const [phone, setPhone] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState("");

  const [services, setServices] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleGiftCardCoupon = async () => {
    let payload;

    if (imageFile) {
      payload = new FormData();
      payload.append("name", name);
      payload.append("priceType", priceType);
      payload.append("expiryDate", format(new Date(expiryDate), "yyyy-MM-dd"));
      payload.append("isActive", isActive);
      validServices.forEach((s) => payload.append("validServices[]", s));
      if (priceType === "fixedPrice") {
        fixedPrices.forEach((p) => payload.append("fixedPrices[]", p));
      }
      if (priceType === "custom" && minPrice) {
        payload.append("minPrice", minPrice);
      }
      if (phone) {
        payload.append("phoneNumber", phone);
      }
      payload.append("image", imageFile);
    } else {
      payload = {
        name,
        priceType,
        expiryDate: format(new Date(expiryDate), "yyyy-MM-dd"),
        isActive,
        validServices,
      };
      if (priceType === "fixedPrice") {
        payload.fixedPrices = fixedPrices;
      }
      if (priceType === "custom" && minPrice) {
        payload.minPrice = minPrice;
      }
      if (phone) {
        payload.phoneNumber = phone;
      }
    }

    try {
      setLoading(true);
      const res = await GIFT_CARDS.create_gift_card(payload);
      toast.success(res.data.message);
      setIsOpen(false);
      setResponseStatus(true);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  // FETCH SERVICES
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await SERVICES.get_all({ business_id: businessId });
        setServices(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  return (
    <Modal setIsOpen={setIsOpen} onClick={() => null} type={1}>
      <div className={styles.container}>
        {/* NAME */}
        <div className={styles.field}>
          <input
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="שם לגיפט *"
          />
        </div>

        {/* PRICE TYPE */}
        <div className={styles.field}>
          <select
            name="priceType"
            value={priceType}
            onChange={(e) => {
              setPriceType(e.target.value);
            }}
          >
            <option value="" disabled selected>
              סוג הגיפט *
            </option>
            <option value="fixedPrice">אני מגדיר את הסכומים לבחירה</option>
            <option value="custom">הלקוח מזין את הסכום</option>
          </select>
        </div>

        {/* FIXED PRICES */}
        {priceType === "fixedPrice" && (
          <>
            <div className={`${styles.field} ${styles.fixedPriceField}`}>
              <input
                type="number"
                value={fixedPrice}
                onChange={(e) => setFixedPrice(e.target.value)}
                placeholder="סכומים מוגדרים *"
              />
              <button
                disabled={!fixedPrice}
                onClick={() => {
                  setFixedPrices((prev) => [...prev, fixedPrice]);
                  setFixedPrice("");
                }}
              >
                +
              </button>
            </div>

            {fixedPrices.length > 0 && (
              <div className={styles.box}>
                {fixedPrices.map((i) => (
                  <p
                    key={i}
                    className={styles.service}
                    onClick={() =>
                      setFixedPrices((prev) => prev.filter((x) => x !== i))
                    }
                  >
                    <span>x</span>
                    {i}
                  </p>
                ))}
              </div>
            )}
          </>
        )}

        {/* MIN PRICE */}
        {priceType === "custom" && (
          <div className={styles.field}>
            <input
              type="number"
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
              placeholder="מחיר מינימום  *"
            />
          </div>
        )}

        {/* EXPIRY DATE */}
        <div className={styles.field}>
          <ReactDatePicker
            selected={expiryDate}
            onChange={setExpiryDate}
            locale={he}
            placeholderText="תוקף *"
            wrapperClassName={styles.exp}
            minDate={new Date()}
          />
        </div>

        {/* PHONE */}
        <div className={styles.field}>
          <input
            name="phone"
            type="number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="טלפון לשליחה"
          />
        </div>

        {/* SWITCH ROW */}
        <div className={styles.switchRow}>
          {/* STATUS */}
          <div className={styles.switchContainer}>
            <ReactSwitch
              checked={isActive}
              onChange={(e) => {
                setIsActive(e);
              }}
              checkedHandleIcon={false}
              uncheckedHandleIcon={false}
              checkedIcon={false}
              uncheckedIcon={false}
              onHandleColor={"#ffffff"}
              offHandleColor={"#ffffff"}
              onColor={"#d00254"}
              offColor={"#d3d3d3"}
              className={styles.switch}
            />
            <p>סטטוס</p>
          </div>
        </div>

        {/* VALID SERVICES */}
        <div className={styles.field}>
          <select
            name="validService"
            value={validService}
            onChange={(e) => {
              setValidService(e.target.value);
              if (!validServices.includes(e.target.value)) {
                setValidServices((prev) => [...prev, e.target.value]);
              }
            }}
          >
            <option value="" disabled selected>
            הקצאה לשירותים ספציפים
            </option>
            {services?.map((i) => (
              <option key={i._id} value={i._id}>
                {i.name}
              </option>
            ))}
          </select>
        </div>

        {/* SERVICES BOX */}
        <div className={styles.box}>
          {validServices.length > 0 ? (
            validServices.map((i) => (
              <div
                className={styles.service}
                onClick={() =>
                  setValidServices((prev) => prev.filter((x) => x !== i))
                }
                key={i}
              >
                <span>x</span>
                {services?.find((j) => j._id === i)?.name}
              </div>
            ))
          ) : (
            <p>ניתן למימוש בכל השירותים</p>
          )}
        </div>

        {/* IMAGE UPLOAD */}
        <div className={styles.field}>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
          <div
            onClick={() => fileInputRef.current.click()}
            style={{
              width: "100%",
              minHeight: "80px",
              border: "2px dashed #d3d3d3",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              overflow: "hidden",
              backgroundColor: "#f9f9f9",
            }}
          >
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="תמונת גיפט"
                style={{ maxHeight: "120px", maxWidth: "100%", objectFit: "contain" }}
              />
            ) : (
              <span style={{ color: "#a7a7a7", fontSize: "14px" }}>
                לחץ להעלאת תמונה לגיפט קארד (אופציונלי)
              </span>
            )}
          </div>
        </div>

        <button
          onClick={handleGiftCardCoupon}
          disabled={
            !name ||
            !priceType ||
            (priceType === "fixedPrice" && fixedPrices.length === 0) ||
            !expiryDate
          }
          className={styles.button}
        >
          {loading ? <Spinner /> : "יצירת גיפט"}
        </button>
      </div>
    </Modal>
  );
};

export default CreateGiftCardModal;
